import {
  Component,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  ChangeDetectorRef,
} from "@angular/core";
import { Title } from "@angular/platform-browser";

import { Observable, Subscription } from "rxjs";

import { TranslateService } from "@ngx-translate/core";

import { BusinessType } from "../models/enums/businessType.enum";
import { AppState, loadedTenantState } from "../store/reducers";
import { select, Store } from "@ngrx/store";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnDestroy {
  langSubscription: Subscription;

  businessTypes = [BusinessType.RETAIL, BusinessType.FLEET];
  selectedBusinessType = BusinessType.RETAIL;

  businessType = BusinessType;

  tenantData$: Observable<any>;

  constructor(
    private translate: TranslateService,
    private titleService: Title,
    private store: Store<AppState>,
  ) {
    this.titleService.setTitle(this.translate.instant("DashBoard.Details"));

    this.tenantData$ = this.store.pipe(select(loadedTenantState));
  }

  public getUserProfileFromStorage() {
    return localStorage.getItem("profileCode") || "";
  }

  setSelectedBusinessType(businessType: BusinessType) {
    this.selectedBusinessType = businessType;
  }

  ngOnDestroy(): void {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }
}
